export default "__VITE_ASSET__G3sR6BiX__"